import React from 'react';

import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Tab = withCoreProps<TabProps>(
  ({ children, className, ...props }: React.PropsWithChildren<TabProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiTab {...props} className={clsxClass}>
        {children}
      </MuiTab>
    );
  },
);

export interface TabProps extends MuiTabProps, CoreProps {}
